// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.productCatd_info__XsEzP {
  font-weight: 600;
  font-size: 12px;
  line-height: 150%;
  color: var(--LowEmphasis);
  margin-bottom: 8px; }

.productCatd_wrapper__-sNvC {
  display: flex; }
  .productCatd_wrapper__-sNvC .productCatd_productTitle__5nxNX {
    font-weight: 600;
    font-size: 12px;
    line-height: 150%;
    color: var(--LowEmphasis); }

.productCatd_title__44nqA {
  font-weight: 600;
  font-size: 12px;
  line-height: 150%;
  color: var(--HightEmphasis);
  margin-bottom: 10px; }

.productCatd_list__i7njg {
  display: flex;
  flex-direction: column;
  border-left: 2px solid var(--Gray88);
  padding-left: 20px;
  gap: 40px; }
`, "",{"version":3,"sources":["webpack://./src/pages/previewOrders/components/ProductCatd/productCatd.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAEA;ECuEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EDvEjB,yBAAyB;EACzB,kBAAkB,EAAA;;AAGpB;EACE,aAAa,EAAA;EADf;ICiEE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;ID/Df,yBAAyB,EAAA;;AAI7B;ECeE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EDfjB,2BAA2B;EAC3B,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;EAClB,SAAS,EAAA","sourcesContent":["@import 'src/styles/fonts';\n\n.info {\n  @include title;\n  color: var(--LowEmphasis);\n  margin-bottom: 8px;\n}\n\n.wrapper {\n  display: flex;\n  .productTitle {\n    @include title;\n    color: var(--LowEmphasis);\n  }\n}\n\n.title {\n  @include h6;\n  color: var(--HightEmphasis);\n  margin-bottom: 10px;\n}\n\n.list {\n  display: flex;\n  flex-direction: column;\n  border-left: 2px solid var(--Gray88);\n  padding-left: 20px;\n  gap: 40px;\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info": `productCatd_info__XsEzP`,
	"wrapper": `productCatd_wrapper__-sNvC`,
	"productTitle": `productCatd_productTitle__5nxNX`,
	"title": `productCatd_title__44nqA`,
	"list": `productCatd_list__i7njg`
};
export default ___CSS_LOADER_EXPORT___;
